import { LogicalConditionOperator } from './generated/graphql.js';

function isSimpleLogicalAndCondition(condition) {
    if (condition.__typename === 'LogicalConditionDefinition' &&
        condition.logicalOperator === LogicalConditionOperator.AND) {
        return condition.conditions.every(subCondition => subCondition.__typename === 'AlwaysTrueConditionDefinition' ||
            subCondition.__typename === 'SubjectIdInConditionDefinition' ||
            subCondition.__typename === 'StringBinaryConditionDefinition');
    }
    return false;
}
function evaluateCondition(subject, condition) {
    switch (condition.__typename) {
        case 'AlwaysTrueConditionDefinition':
            return true;
        case 'SubjectIdInConditionDefinition':
            return condition.subjectIds.includes(subject.id);
        case 'StringBinaryConditionDefinition':
            const attributeValue = subject.attributes && subject.attributes[condition.attributeName];
            switch (condition.stringBinaryOperator) {
                case 'IN':
                    return (attributeValue !== null &&
                        attributeValue !== undefined &&
                        condition.attributeValues.includes(attributeValue));
                case 'NOT_IN':
                    return (attributeValue !== null &&
                        attributeValue !== undefined &&
                        !condition.attributeValues.includes(attributeValue));
                case 'EXISTS':
                    return attributeValue !== null && attributeValue !== undefined;
                case 'NOT_EXISTS':
                    return attributeValue === null || attributeValue === undefined;
                default:
                    throw 'String binary operator ' + condition.stringBinaryOperator + ' not supported';
            }
        case 'LogicalConditionDefinition':
            if (isSimpleLogicalAndCondition(condition)) {
                for (const innerCondition of condition.conditions) {
                    if (!evaluateCondition(subject, innerCondition))
                        return false;
                }
                return true;
            }
            else {
                throw 'Logical operator' + condition.logicalOperator + ' not supported';
            }
        default:
            throw 'Condition type ' + condition.type + ' not supported';
    }
}

export { evaluateCondition, isSimpleLogicalAndCondition };
//# sourceMappingURL=condition.js.map
